import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProveedorService } from '@app/core/service/proveedor.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-crear-proveedor',
  templateUrl: './crear-proveedor.component.html',
  styleUrls: ['./crear-proveedor.component.css']
})
export class CrearProveedorComponent implements OnInit {
  form: FormGroup;
  @Input() title: string;
  @Input() id: any;
  @Input() estado: boolean;

  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private proveedorService: ProveedorService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.createForm();
    if (this.estado) {
      this.proveedorService.getById(this.id).subscribe(data => {
        this.form.patchValue({
          nombre: data.nombre,
          celular: data.celular,
          descripcion: data.descripcion
        });
      });
    }
  }

  createForm() {
    this.form = this.fb.group({
      nombre: ['', Validators.required],
      celular: [''],
      descripcion: ['']
    });
  }

  registrarProveedor(form: any) {
    if (this.estado === true) {
      this.isLoading = true;

      this.proveedorService
        .update(this.id, form)
        .pipe(
          finalize(() => {
            this.form.markAsPristine();
            this.isLoading = false;
          })
        )
        .subscribe(
          data => {
            Swal.fire(data);
            this.form.reset();
            this.activeModal.close(data);
          },
          error1 => {
            Swal.fire(error1.error);
          }
        );
    } else {
      this.isLoading = true;
      this.proveedorService
        .create(form)
        .pipe(
          finalize(() => {
            this.form.markAsPristine();
            this.isLoading = false;
          })
        )
        .subscribe(
          data => {
            Swal.fire(data.success);
            this.form.reset();
            this.activeModal.close(data);
          },
          error1 => {
            Swal.fire(error1.error);
          }
        );
    }
  }
}
